import React from 'react';
import { ButtonRadio, Field, Select, Textarea } from '../Common';
import readFile from '../../utils/readFile';
import { download } from '../../api/api';

const music = {
	    id: '',
	    titre: '',
	    auteur: '',
	    error: {
	        titre: '',
	        auteur: '',
	    }
	}

export default class CeremonyForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ceremony: this.props.data && this.props.data.typeCeremonie ? this.props.data.typeCeremonie : 'Civile',
            religiousDenomination: this.props.data && this.props.data.confessionReligieuse ? this.props.data.confessionReligieuse : '',
            texteAutre: this.props.data && this.props.data.texteAutre ? this.props.data.texteAutre : '',
            ceremonyPlace: this.props.data && this.props.data.addresseCeremonie ? this.props.data.addresseCeremonie : '',
            town: this.props.data && this.props.data.villeCeremonie ? this.props.data.villeCeremonie : '',
            zipCode: this.props.data && this.props.data.codePostalCeremonie ? this.props.data.codePostalCeremonie : '',
            country: this.props.data && this.props.data.paysCeremonie ? this.props.data.paysCeremonie : "79",
            inhumation: this.props.data && this.props.data.enterrement ? "true" : "false",
            inhumationPlace: this.props.data && this.props.data.enterrement && this.props.data.enterrement.cimetiere ? 'DANS_CIMETIERE' : 'HORS_CIMETIERE',
            dispersion: this.props.data && this.props.data.incineration && this.props.data.incineration.modeDispersionCendres ? "1" : "0",
            dispersionPlace: this.props.data && this.props.data.incineration && this.props.data.incineration.modeDispersionCendres ? this.props.data.incineration.modeDispersionCendres : 'CIMETIERE',
            ashesDelivery: this.props.data && this.props.data.incineration && this.props.data.incineration.remiseUrne ? this.props.data.incineration.remiseUrne : 'FAMILLE',
            cemeteryName: this.props.data && this.props.data.enterrement && this.props.data.enterrement.addresseCimetiere ? this.props.data.enterrement.addresseCimetiere : this.props.data && this.props.data.incineration && this.props.data.incineration.addresseCimetiere ? this.props.data.incineration.addresseCimetiere : '',
            cemeteryZipCode: this.props.data && this.props.data.enterrement && this.props.data.enterrement.codePostalCimetiere ? this.props.data.enterrement.codePostalCimetiere : this.props.data && this.props.data.incineration && this.props.data.incineration.codePostalCimetiere ? this.props.data.incineration.codePostalCimetiere : '',
            cemeteryTown: this.props.data && this.props.data.enterrement && this.props.data.enterrement.villeCimetiere ? this.props.data.enterrement.villeCimetiere : this.props.data && this.props.data.incineration && this.props.data.incineration.villeCimetiere ? this.props.data.incineration.villeCimetiere : '',
            cemeteryCountry: this.props.data && this.props.data.enterrement && this.props.data.enterrement.paysCimetiere ? this.props.data.enterrement.paysCimetiere : this.props.data && this.props.data.incineration && this.props.data.incineration.paysCimetiere ? this.props.data.incineration.paysCimetiere : "79",
            musicAuthor: this.props.data && this.props.data.auteurMusiqueCeremonie ? this.props.data.auteurMusiqueCeremonie : '',
            musicTitle: this.props.data && this.props.data.titreMusiqueCeremonie ? this.props.data.titreMusiqueCeremonie : '',
            music: this.props.data && this.props.data.music && this.props.data.music.length > 0 ? this.props.data.music : [{ ...music , id: '0' }], 
            concession: this.props.data && this.props.data.enterrement && this.props.data.enterrement.concession ? this.props.data && this.props.data.enterrement && this.props.data.enterrement.caveauFamiliale ? "1" : "2" : "0",
            countryList: props.countryData.list,
            files: [],
            showDelete: false,
            upload: false,
            error: {
                religiousDenomination: '',
                texteAutre: '',
                ceremonyPlace: '',
                town: '',
                country: '',
                zipCode: '',
                cemeteryName: '',
                cemeteryZipCode: '',
                cemeteryTown: '',
                cemeteryCountry: '',
                files: '',
            }
        }
    }

    componentDidMount() {
        if ( this.props.data 
            && this.props.data.texteCeremonie 
            && this.props.data.texteCeremonie.filename ) {
                let file = { name: this.props.data.texteCeremonie.filename };
                this.state.files.push(file);
                this.setState({ showDelete: true, files: this.state.files });
            }
    }

    addMusic = () => {
    	const id = this.state.music.length;
    	let disabled = false;
        const newMusic = {
            ...music,
            id 
        }
        if ( id === 4 ) {
        	disabled = true;
        }
        this.setState(prevState => ({
            music: [...prevState.music, newMusic],
            disabled: disabled
        }));
    }
    
    removeMusic = (id) => {
    	const _id = id;
        const music = this.state.music.filter(({ id }) => id !== _id);
        this.setState(() => ({ music }));
        if ( music.length < 5 ) {
        	this.setState({ disabled: false });
        }
    }
    
    onMusicChange(key, e) {
        const index = e.target.name;
        const value = e.target.value;
        this.setState(prevState => ({
            music: prevState.music.map(
                obj => (obj.id == index ? { ...obj, [key]: value } : obj)
            )
        }));
    }
    
    handleOnChange(key, e) {
        const value = e.target.value;
        this.setState({ [key]: value })
    }

    handleFileChange = (e) => {
        const files = e.target.files;
        const fileSize = files[0] && files[0].size / 1024 / 1024;
        if ( fileSize > 500 ) {
            this.setState(prevState => ({
                files: [],
                error: {
                    ...prevState.error,
                    files: ' La taille du fichier ne doit pas dépasser 500 Mo'
                }
            }))
        } else
            if (files[0] && this.validFile(files[0].name)) {
                this.setState(prevState => ({
                    files,
                    showDelete: true,
                    upload: true,
                    error: {
                        ...prevState.error,
                        files: ''
                    }
                }))
            } else {
                this.setState(prevState => ({
                    files: [],
                    error: {
                        ...prevState.error,
                        files: ' Merci de choisir un fichier de cette liste [ doc, docx, pdf, txt]'
                    }
                }))
            }
    }

    validFile = name => {
        const list = ['doc', 'docx', 'pdf', 'txt'];
        if (name) {
            const s = name.toLowerCase().split('.')[name.split('.').length - 1];
            if (list.indexOf(s) > -1)
                return true
        }
        return false
    }

    getFile = (fileName) => {
        const data = {
            'file': `${this.props.idBeneficiaire}/${fileName}`
        }
        download(data, this.props.idPartenaire).then(data => {
            readFile(data.response, fileName, data.type, 'text');
        }, error => {
            // handle errors
        });
    }

    deleteFile = (fileName) => {
        this.setState(() => ({ files: [], showDelete: false } ));

        let file = new FormData();
        file.append('fileName', fileName);
        file.append('fileType', 'TEXT_CEREMONY');
        file.append('idBeneficiaire', this.props.idBeneficiaire);
        this.props.deleteFile(file);
    }


    onSubmit = (e) => {
        e.preventDefault();

        let religiousDenomination = '';
        let texteAutre = '';
        let ceremonyPlace = '';
        let zipCode = '';
        let town = '';
        let country = '';
        let cemeteryName = '';
        let cemeteryTown = '';
        let cemeteryZipCode = '';
        let cemeteryCountry = '';
        let dispersionPlace = '';
        let data = {
            typeCeremonie: this.state.ceremony,
            confessionReligieuse: this.state.ceremony.toUpperCase() === 'RELIGIEUSE'.toUpperCase() ? this.state.religiousDenomination : '',
            texteAutre: this.state.ceremony.toUpperCase() === 'AUTRE'.toUpperCase() ? this.state.texteAutre : '',
            addresseCeremonie: this.state.ceremonyPlace,
            villeCeremonie: this.state.town,
            paysCeremonie: this.state.country,
            codePostalCeremonie: this.state.zipCode,
            texteCeremonie: this.state.file,
            auteurMusiqueCeremonie: this.state.musicAuthor,
            titreMusiqueCeremonie: this.state.musicTitle,
            music: this.state.music
        };
        if (data.texteCeremonie != null && data.texteCeremonie.name) {
            data.texteCeremonie.filename = data.texteCeremonie.name;
        }

        let c = null;
        let cf = null;
        // INHUMATION
        if (this.state.inhumation == "true") {
            if (this.state.concession == "0") {
                c = false;
            } else {
                c = true;
                if (this.state.concession == "1") {
                    cf = true;
                } else {
                    cf = false;
                }
            }
            data.enterrement = {
                concession: c,
                caveauFamiliale: cf,
                cimetiere: this.state.inhumationPlace == "DANS_CIMETIERE",
                addresseCimetiere: this.state.cemeteryName,
                villeCimetiere: this.state.cemeteryTown,
                codePostalCimetiere: this.state.cemeteryZipCode,
                paysCimetiere: this.state.cemeteryCountry
            }
            cemeteryName = (!this.state.cemeteryName) && ' is-invalid';
            cemeteryTown = (!this.state.cemeteryTown) && ' is-invalid';
            cemeteryZipCode = (!this.state.cemeteryZipCode) && ' is-invalid';
            cemeteryCountry = (!this.state.cemeteryCountry) && ' is-invalid';
        } else {
            // CREMATION
            data.incineration = {
                concession: c,
                caveauFamiliale: cf,
                cimetiere: this.state.inhumationPlace == "DANS_CIMETIERE",
                remiseUrne: this.state.ashesDelivery,
            }
            if ( this.state.dispersion === "1" ) {
                data.incineration.modeDispersionCendres = this.state.dispersionPlace;
                data.incineration.remiseUrne = "";
            }
            if ((this.state.dispersion === "1" && this.state.dispersionPlace == "CIMETIERE") /*|| this.state.dispersion === "0"*/) {
                cemeteryName = (!this.state.cemeteryName) && ' is-invalid';
                cemeteryTown = (!this.state.cemeteryTown) && ' is-invalid';
                cemeteryZipCode = (!this.state.cemeteryZipCode) && ' is-invalid';
                cemeteryCountry = (!this.state.cemeteryCountry) && ' is-invalid';
                data.incineration.addresseCimetiere = this.state.cemeteryName,
                    data.incineration.villeCimetiere = this.state.cemeteryTown,
                    data.incineration.codePostalCimetiere = this.state.cemeteryZipCode,
                    data.incineration.paysCimetiere = this.state.cemeteryCountry
            }
        }

        ceremonyPlace = (!this.state.ceremonyPlace) && ' is-invalid';
        zipCode = (!this.state.zipCode) && ' is-invalid';
        town = (!this.state.town) && ' is-invalid';
        country = (!this.state.country) && ' is-invalid';

        this.setState(prevState => ({
            error: {
                ...prevState.error,
                //religiousDenomination,
                ceremonyPlace,
                zipCode,
                town,
                country,
                cemeteryName,
                cemeteryTown,
                cemeteryZipCode,
                cemeteryCountry,
                dispersionPlace
            }
        }))
        data.showDelete = this.state.showDelete;
        data.uplodad = this.state.upload;

        if ( this.state.ceremony.toUpperCase() === 'AUTRE' ) {
            ceremonyPlace = '';
            zipCode = '';
            town = '';
            country = '';
            data.addresseCeremonie = '';
            data.villeCeremonie = '';
            data.paysCeremonie = '';
            data.codePostalCeremonie = '';
        }

        if (//!religiousDenomination &&
            !ceremonyPlace
            && !zipCode
            && !town
            && !country
            && !cemeteryName
            && !cemeteryTown
            && !cemeteryZipCode
            && !cemeteryCountry
            && !dispersionPlace
        ) {
            if (this.state.upload && this.state.files && this.state.files.length > 0) {
                data.file = new FormData();
                data.file.append('file', this.uploadInput.files[0]);
                data.file.append('fileType', 'TEXT_CEREMONY');
                data.file.append('idBeneficiaire', this.props.idBeneficiaire);
            } else {
                data.file = '';
            }
            this.props.onCeremonySubmit(data);
        } else  {
        	window.scrollTo(0, 0);
        }
    }

    showTooltip = (event) => {
        let el = event.target;
        console.log(el);
    }

    hideTooltip = (event) => {
        let el = event.target;
        console.log(el);
    }

    render() {
        const divStyle = {
			display: 'inline-flex'
		};
        return (
            <form onSubmit={this.onSubmit} className="funeral-form" encType="multipart/form-data">
                <div className="col-sm-12 form-container">
                    <div className="row">
                        <div className="col">
                            <h4 className="top-title"><div className="icon-title _ceremony"></div>Je souhaite une cérémonie* : </h4>
                            <div className="form-group margin-left">
                                <ButtonRadio
                                    type="radio"
                                    _id="radioFp1"
                                    name="ceremony"
                                    value="Civile"
                                    checked={this.state.ceremony.toUpperCase() == "CIVILE".toUpperCase()}
                                    onChange={this.handleOnChange.bind(this, 'ceremony')}
                                />
                                <ButtonRadio
                                    type="radio"
                                    _id="radioFp2"
                                    name="ceremony"
                                    className="custom-control-input"
                                    value="Religieuse"
                                    checked={this.state.ceremony.toUpperCase() == "RELIGIEUSE".toUpperCase()}
                                    onChange={this.handleOnChange.bind(this, 'ceremony')}
                                />
                                <ButtonRadio
                                    type="radio"
                                    _id="radioFp17"
                                    name="ceremony"
                                    className="custom-control-input"
                                    value="Autre"
                                    checked={this.state.ceremony.toUpperCase() == "AUTRE".toUpperCase()}
                                    onChange={this.handleOnChange.bind(this, 'ceremony')}
                                />
                            </div>
                        </div>
                        <div className="col">
                            {
                                this.state.ceremony.toUpperCase() == "AUTRE".toUpperCase() &&
                                <Textarea
                                    _className={"form-control obituary-text " + this.state.error.texteAutre}
                                    placeholder="900 caractères maximum - espaces compris"
	                                value={this.state.texteAutre}
	                                onChange={this.handleOnChange.bind(this, "texteAutre")}
	                                rows="8"
	                                error={this.state.error.texteAutre}
	                                errorMessage=" Veuillez entrer le texte de votre choix de cérémonie."
	                                label="Commentaires"
	                            />
                            } 
                            {
                                this.state.ceremony.toUpperCase() == "RELIGIEUSE".toUpperCase() &&
                                <Field
                                    label="Confession religieuse"
                                    error={this.state.error.religiousDenomination}
                                    type="text"
                                    _className={"form-control newspapers " + this.state.error.religiousDenomination}
                                    value={this.state.religiousDenomination}
                                    onChange={this.handleOnChange.bind(this, 'religiousDenomination')}
                                />
                            }
                            { this.state.ceremony.toUpperCase() != "AUTRE".toUpperCase() &&
	                            <Field
	                                label="Lieu de cérémonie"
	                                error={this.state.error.ceremonyPlace}
	                                type="text"
	                                _className={"form-control newspapers " + this.state.error.ceremonyPlace}
	                                value={this.state.ceremonyPlace}
	                                onChange={this.handleOnChange.bind(this, 'ceremonyPlace')}
	                            />
                            }
                            { this.state.ceremony.toUpperCase() != "AUTRE".toUpperCase() &&
	                            <div className="row zip-container">
	                                <div className="col-4 _col-first">
	                                    <Field
	                                        label="Code postal *"
	                                        error={this.state.error.zipCode}
	                                        type="text"
	                                        _className={"form-control " + this.state.error.zipCode}
	                                        //placeholder="97860"
	                                        value={this.state.zipCode}
	                                        onChange={this.handleOnChange.bind(this, 'zipCode')}
	                                    />
	                                </div>
	                                <div className="col">
	                                    <Field
	                                        label="Commune *"
	                                        error={this.state.error.town}
	                                        type="text"
	                                        _className={"form-control " + this.state.error.town}
	                                        ////placeholder="VILLETANEUSE"
	                                        value={this.state.town}
	                                        onChange={this.handleOnChange.bind(this, 'town')}
	                                    />
	                                </div>
	                            </div>
                            }
                            { this.state.ceremony.toUpperCase() != "AUTRE".toUpperCase() &&
	                            <Select
	                                label="Pays *"
	                                error={this.state.error.country}
	                                _className={"form-control address " + this.state.error.country}
	                                ////placeholder="France"
	                                value={this.state.country}
	                                onChange={this.handleOnChange.bind(this, 'country')}
	                                list={this.state.countryList}
	                                selectType="obj"
	                                optionValue="id"
	                                optionLabel="libelle"
	                            />
                            }
                        </div>

                    </div>
                    <div className="separator-list"></div>

                    <div className="row">
                        <div className="col">
                            <h4 className="top-title"><div className="icon-title _cimetery"></div>Je souhaite être* : </h4>
                            <div className="form-group margin-left">
                                <ButtonRadio
                                    type="radio"
                                    _id="radioFp3"
                                    name="inhumation"
                                    className="custom-control-input"
                                    value="true"
                                    checked={this.state.inhumation == "true"}
                                    onChange={this.handleOnChange.bind(this, 'inhumation')}
                                    label="Inhumé(e)"
                                />
                                <ButtonRadio
                                    type="radio"
                                    _id="radioFp4"
                                    name="inhumation"
                                    className="custom-control-input"
                                    value="false"
                                    checked={this.state.inhumation == "false"}
                                    onChange={this.handleOnChange.bind(this, 'inhumation')}
                                    label="Incinéré(e)"
                                />
                            </div>
                            {    // INHUMATION  
                                this.state.inhumation == "true" &&
                                <div>
                                    <div className="form-group margin-left">
                                        <ButtonRadio
                                            type="radio"
                                            _id="radioFp13"
                                            name="inhumationPlace"
                                            className="custom-control-input"
                                            value="DANS_CIMETIERE"
                                            label="Dans un cimetière"
                                            checked={this.state.inhumationPlace == "DANS_CIMETIERE"}
                                            onChange={this.handleOnChange.bind(this, 'inhumationPlace')}
                                        />
                                        <ButtonRadio
                                            type="radio"
                                            _id="radioFp14"
                                            name="inhumationPlace"
                                            className="custom-control-input"
                                            value="HORS_CIMETIERE"
                                            label="Hors cimetière"
                                            checked={this.state.inhumationPlace == "HORS_CIMETIERE"}
                                            onChange={this.handleOnChange.bind(this, 'inhumationPlace')}
                                        />
                                        <div className="htmlTooltip horsCimetiere"
                                            tabIndex="0"
                                        >
                                            <span className="tooltiptext">
                                                <p>Dans la législation française, une personne peut être inhumée dans le jardin d'une propriété particulière si les 2 conditions suivantes sont remplies :</p>
                                                <ul>
                                                    <li>la propriété doit être située hors de l'enceinte des villes et bourgs et à la distance prescrite,</li>
                                                    <li>l'autorisation du préfet doit avoir été accordée.</li>
                                                </ul>
                                            </span>
                                        </div>
                                    </div>
                                    {   // IF INHUMATION IN CIMETRY
                                        this.state.inhumationPlace == "DANS_CIMETIERE" &&
                                        <div>
                                            <div className="form-group margin-left">
                                                <label>J'ai une concession</label>
                                                <ButtonRadio
                                                    type="radio"
                                                    _id="radioFp15"
                                                    name="concession"
                                                    className="custom-control-input"
                                                    value="1"
                                                    checked={this.state.concession == "1"}
                                                    onChange={this.handleOnChange.bind(this, 'concession')}
                                                    label="Oui avec caveau de famille"
                                                />
                                                <ButtonRadio
                                                    type="radio"
                                                    _id="radioFp21"
                                                    name="concession"
                                                    className="custom-control-input"
                                                    value="2"
                                                    checked={this.state.concession == "2"}
                                                    onChange={this.handleOnChange.bind(this, 'concession')}
                                                    label="Oui sans caveau de famille"
                                                />
                                                <ButtonRadio
                                                    type="radio"
                                                    _id="radioFp16"
                                                    name="concession"
                                                    className="custom-control-input"
                                                    value="0"
                                                    checked={this.state.concession == "0"}
                                                    onChange={this.handleOnChange.bind(this, 'concession')}
                                                    label="Non"
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            {    // CRÉMATION
                                this.state.inhumation == "false" &&
                                <div>
                                    <div className="form-group margin-left">
                                        <label>Avec dispersion des cendres</label>
                                        <div className="htmlTooltip dispersionCendres"
                                            tabIndex="0"
                                        >
                                            <span className="tooltiptext">
                                                <p>Dans la législation française, la dispersion des cendres est autorisée dans les 3 endroits suivants :</p>
                                                <ul>
                                                    <li>La dispersion des cendres au cimetière se fait dans le jardin des souvenirs. Cet espace de dispersion est souvent délimité par des bordures et matérialisé en sous-sol par un puisard ou réceptacle sans fond permettant de respecter les cendres telles un corps (loi de décembre 2008).</li>
                                                    <li>La dispersion dans la nature peut se faire :
                                        			<ol>
                                                            <li>dans les espaces naturels non aménagés, ou lieux de pleine nature, comme grandes étendues accessibles au public, telles que des forêts, champs ou haute montagne. La “personne ayant qualité pour pourvoir aux funérailles” doit effectuer une déclaration à la mairie du lieu de naissance du défunt.</li>
                                                            <li>dans les grandes étendues accessibles au public mais appartenant à une personne privée (jardins, parcs, champs, prairies, forêts, etc.) sous réserve d’obtenir au préalable une autorisation préfectorale. Il sera également nécessaire d’obtenir l’accord du propriétaire.</li>
                                                            <li>par voie aérienne si cette dispersion intervient en surplomb d’espaces naturels totalement dépourvus de voies publiques.</li>
                                                        </ol>
                                                    </li>
                                                    <li>La dispersion dans la mer est autorisée en pleine mer et la déclaration s’effectue auprès du maire de la commune de mouillage de départ du bateau. Pour les fleuves et rivières, la dispersion des cendres est interdite.</li>
                                                </ul>
                                                <p>Toute dispersion dans les lieux publics est interdite. Par ailleurs, la création, gestion ou possession de tout lieu collectif destiné au dépôt des urnes ou dispersion des cendres est interdite. Cette infraction est sanctionnable d’une amende de 15 000 €.</p>
                                            </span>
                                        </div>
                                        <ButtonRadio
                                            type="radio"
                                            _id="radioFp5"
                                            name="dispersion"
                                            className="custom-control-input"
                                            value="1"
                                            checked={this.state.dispersion == "1"}
                                            onChange={this.handleOnChange.bind(this, 'dispersion')}
                                            label="Oui"
                                        />
                                        <ButtonRadio
                                            type="radio"
                                            _id="radioFp6"
                                            name="dispersion"
                                            className="custom-control-input"
                                            value="0"
                                            checked={this.state.dispersion == "0"}
                                            onChange={this.handleOnChange.bind(this, 'dispersion')}
                                            label="Non"
                                        />
                                    </div>
                                    {    // IF DISPERSION  
                                        this.state.dispersion == "1" &&
                                        <div>
                                            <div className="form-group margin-left">
                                                <label>Je souhaite que mes cendres soient dispersées</label>
                                                <ButtonRadio
                                                    type="radio"
                                                    _id="radioFp7"
                                                    name="dispersionPlace"
                                                    className="custom-control-input"
                                                    label="Au cimetière"
                                                    value="CIMETIERE"
                                                    checked={this.state.dispersionPlace == "CIMETIERE"}
                                                    onChange={this.handleOnChange.bind(this, 'dispersionPlace')}
                                                />
                                                <ButtonRadio
                                                    type="radio"
                                                    _id="radioFp8"
                                                    name="dispersionPlace"
                                                    className="custom-control-input"
                                                    label="Dans la nature"
                                                    value="NATURE"
                                                    checked={this.state.dispersionPlace == "NATURE"}
                                                    onChange={this.handleOnChange.bind(this, 'dispersionPlace')}
                                                />
                                                <ButtonRadio
                                                    type="radio"
                                                    _id="radioFp9"
                                                    name="dispersionPlace"
                                                    className="custom-control-input"
                                                    label="Dans la mer"
                                                    value="MER"
                                                    checked={this.state.dispersionPlace == "MER"}
                                                    onChange={this.handleOnChange.bind(this, 'dispersionPlace')}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {
                                        // IF NOT DISPERSION  
                                        this.state.dispersion == "0" &&
                                        <div className="form-group margin-left">
                                            <label>Je souhaite que mes cendres soient</label>
                                            <ButtonRadio
                                                type="radio"
                                                _id="radioFp10"
                                                name="ashesDelivery"
                                                className="custom-control-input"
                                                label="Remises à ma famille"
                                                value="FAMILLE"
                                                checked={this.state.ashesDelivery == "FAMILLE"}
                                                onChange={this.handleOnChange.bind(this, 'ashesDelivery')}
                                            />
                                            <ButtonRadio
                                                type="radio"
                                                _id="radioFp11"
                                                name="ashesDelivery"
                                                className="custom-control-input"
                                                label="Remises au columbarium"
                                                value="COLUMBARIUM"
                                                checked={this.state.ashesDelivery == "COLUMBARIUM"}
                                                onChange={this.handleOnChange.bind(this, 'ashesDelivery')}
                                            />
                                            <ButtonRadio
                                                type="radio"
                                                _id="radioFp12"
                                                name="ashesDelivery"
                                                className="custom-control-input"
                                                label="Déposées dans mon caveau"
                                                value="CAVEAU"
                                                checked={this.state.ashesDelivery == "CAVEAU"}
                                                onChange={this.handleOnChange.bind(this, 'ashesDelivery')}
                                            />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <div className="col">
                            {
                                // IF INHUMATION IN CIMETRY
                                this.state.inhumation == "true" &&
                                this.state.inhumationPlace == "DANS_CIMETIERE" &&
                                <div className="cemetry-container">
                                    <Field
                                        label="Nom du cimetière"
                                        type="text"
                                        error={this.state.error.cemeteryName}
                                        _className={"form-control newspapers " + this.state.error.cemeteryName}
                                        value={this.state.cemeteryName}
                                        onChange={this.handleOnChange.bind(this, 'cemeteryName')}
                                    />
                                    <div className="row zip-container">
                                        <div className="col-4 _col-first">
                                            <Field
                                                label="Code postal *"
                                                type="text"
                                                error={this.state.error.cemeteryZipCode}
                                                _className={"form-control " + this.state.error.cemeteryName}
                                                //placeholder="97860"
                                                value={this.state.cemeteryZipCode}
                                                onChange={this.handleOnChange.bind(this, 'cemeteryZipCode')}
                                            />
                                        </div>
                                        <div className="col">
                                            <Field
                                                label="Commune *"
                                                type="text"
                                                error={this.state.error.cemeteryTown}
                                                _className={"form-control " + this.state.error.cemeteryTown}
                                                //placeholder="VILLETANEUSE"
                                                value={this.state.cemeteryTown}
                                                onChange={this.handleOnChange.bind(this, 'cemeteryTown')}
                                            />
                                        </div>
                                    </div>
                                    <Select
                                        label="Pays *"
                                        error={this.state.error.cemeteryCountry}
                                        _className={"form-control address" + this.state.error.cemeteryCountry}
                                        //placeholder="France"
                                        value={this.state.cemeteryCountry}
                                        onChange={this.handleOnChange.bind(this, 'cemeteryCountry')}
                                        list={this.state.countryList}
                                        selectType="obj"
                                        optionValue="id"
                                        optionLabel="libelle"
                                    />
                                </div>
                            }
                            {
                                // IF INHUMATION OUT CIMETRY
                                this.state.inhumation == "true" &&
                                this.state.inhumationPlace == "HORS_CIMETIERE" &&
                                <div className="cemetry-container">
                                    <Field
                                        label="Adresse la propriété *"
                                        type="text"
                                        error={this.state.error.cemeteryName}
                                        _className={"form-control newspapers " + this.state.error.cemeteryName}
                                        value={this.state.cemeteryName}
                                        onChange={this.handleOnChange.bind(this, 'cemeteryName')}
                                    />
                                    <div className="row zip-container">
                                        <div className="col-4 _col-first">
                                            <Field
                                                label="Code postal *"
                                                type="text"
                                                error={this.state.error.cemeteryZipCode}
                                                _className={"form-control " + this.state.error.cemeteryName}
                                                //placeholder="97860"
                                                value={this.state.cemeteryZipCode}
                                                onChange={this.handleOnChange.bind(this, 'cemeteryZipCode')}
                                            />
                                        </div>
                                        <div className="col">
                                            <Field
                                                label="Commune *"
                                                type="text"
                                                error={this.state.error.cemeteryTown}
                                                _className={"form-control " + this.state.error.cemeteryTown}
                                                //placeholder="VILLETANEUSE"
                                                value={this.state.cemeteryTown}
                                                onChange={this.handleOnChange.bind(this, 'cemeteryTown')}
                                            />
                                        </div>
                                    </div>
                                    <Select
                                        label="Pays *"
                                        error={this.state.error.cemeteryCountry}
                                        _className={"form-control address" + this.state.error.cemeteryCountry}
                                        //placeholder="France"
                                        value={this.state.cemeteryCountry}
                                        onChange={this.handleOnChange.bind(this, 'cemeteryCountry')}
                                        list={this.state.countryList}
                                        selectType="obj"
                                        optionValue="id"
                                        optionLabel="libelle"
                                    />
                                </div>
                            }
                            {   // IF CREMATION  
                                this.state.inhumation == "false" && (/*this.state.dispersion == "0" ||*/ (this.state.dispersion == "1" && this.state.dispersionPlace == "CIMETIERE")) &&
                                <div>
                                    <div className="cemetry-container">
                                        <Field
                                            label="Nom du cimetière"
                                            type="text"
                                            error={this.state.error.cemeteryName}
                                            _className={"form-control newspapers " + this.state.error.cemeteryName}
                                            value={this.state.cemeteryName}
                                            onChange={this.handleOnChange.bind(this, 'cemeteryName')}
                                        />
                                        <div className="row zip-container">
                                            <div className="col-4 _col-first">
                                                <Field
                                                    label="Code postal *"
                                                    type="text"
                                                    error={this.state.error.cemeteryZipCode}
                                                    _className={"form-control " + this.state.error.cemeteryName}
                                                    //placeholder="97860"
                                                    value={this.state.cemeteryZipCode}
                                                    onChange={this.handleOnChange.bind(this, 'cemeteryZipCode')}
                                                />
                                            </div>
                                            <div className="col">
                                                <Field
                                                    label="Commune *"
                                                    type="text"
                                                    error={this.state.error.cemeteryTown}
                                                    _className={"form-control " + this.state.error.cemeteryTown}
                                                    //placeholder="VILLETANEUSE"
                                                    value={this.state.cemeteryTown}
                                                    onChange={this.handleOnChange.bind(this, 'cemeteryTown')}
                                                />
                                            </div>
                                        </div>
                                        <Select
                                            label="Pays *"
                                            error={this.state.error.cemeteryCountry}
                                            _className={"form-control address " + this.state.error.cemeteryCountry}
                                            //placeholder="France"
                                            value={this.state.cemeteryCountry}
                                            onChange={this.handleOnChange.bind(this, 'cemeteryCountry')}
                                            list={this.state.countryList}
                                            selectType="obj"
                                            optionValue="id"
                                            optionLabel="libelle"
                                        />
                                    </div>

                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 form-container">
                        <div className="separator-list"></div>
                        <div className="form-group">
                            <h4 className="top-title _sub">
                                <div className="icon-title _text"></div>
                                Lors de la cérémonie, je souhaite que ce texte soit lu à haute voix :
                            <div className="tooltip-toggle btn-info-tooltip"
                                    aria-label="Merci de choisir un fichier de cette liste [ doc, docx, pdf, txt]"
                                    tabIndex="0"
                                >
                                </div>
                            </h4>
                            {this.props.data 
                            	&& this.props.data.texteCeremonie 
                                && this.props.data.texteCeremonie.filename 
                                && this.state.showDelete
                                &&
                                <div style={divStyle}>
                                    <div className="div-link text-link" onClick={() => this.getFile(this.props.data.texteCeremonie && this.props.data.texteCeremonie.filename)}>
                                        Télécharger le texte sauvegardé
                                    </div>
                                    <div className="div-link text-link" onClick={() => this.deleteFile(this.props.data.texteCeremonie && this.props.data.texteCeremonie.filename)}>
                                        Supprimer
                                    </div>
                                </div>
                            }
                            <div className="custom-file margin-left">
                                <input
                                    type="file"
                                    className={this.state.error.files ? "custom-file-input is-invalid" : "custom-file-input" }
                                    id="customFile"
                                    ref={(ref) => { this.uploadInput = ref; }}
                                    onChange={this.handleFileChange}
                                />
                                <label className="custom-file-label" htmlFor="customFile" data-browse="">
                                    <div>
                                        {this.state.files[0] && this.state.files[0].name}
                                    </div>
                                </label>
                                {this.state.error.files &&
                                    <div className="invalid-feedback error-files">
                                       {this.state.error.files}
                                </div>
                                }
                            </div>
                        </div>
                        <div className="separator-list"></div>
                        <h4 className="top-title"> Lors de la cérémonie, je souhaite que cette musique soit écoutée :</h4>
                        {this.state.music && this.state.music.map((item, i) =>
                        <div className="row" key={i}>
	                        <div className="col-sm-12 form-container">
	                        	<div className="first-person">
			                        {i > 0 &&
			                      	  <div className="delete-item-button" onClick={() => this.removeMusic(item.id)} >&nbsp;Supprimer&nbsp;</div>
			                        }
		                            <h4 className="top-title"><div className="icon-title _music"></div>Musique {i + 1} </h4>
				                    <div className="row">
				                    	<div className="col">
				                         	<Field
				                               	label="Titre"
			                               		type="text"
		                                        name={item.id}
				                                _className="form-control address"
				                                //placeholder="VILLETANEUSE"
				                                value={item.titre}
				                              	onChange={this.onMusicChange.bind(this, "titre")}
				                         	/>
				                        </div>
				                        <div className="col">
				                        	<Field
				                            	label="Auteur/interprète/compositeur"
				                                type="text"
			                                    name={item.id}
				                                _className="form-control address"
				                                //placeholder="VILLETANEUSE"
				                                value={item.auteur}
				                                onChange={this.onMusicChange.bind(this, 'auteur')}
				                            />
				                        </div>
				                    </div>
	                          	</div>
	                      	</div>
	                      </div>
                        )}
                    </div>
                    <div className="col-sm-12 form-container align-center">
                    
                    	<button type="button" className="btn btn-outline-primary btn-sm btn-icon" onClick={this.addMusic} disabled={this.state.disabled}><div className="icon-button">+</div>  Ajouter musique  </button>
                    	
                    	<div className="required-txt"> * Champs obligatoires</div>
                        <div className="button-container">
                            <button className="btn btn-outline-primary" onClick={this.props.back}>ANNULER</button>
                            <button type="submit" className="btn btn-primary">Suivant ></button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FuneralPage/CeremonyForm.js